import { DaoModel } from '@dynameat/models';

export class GroupOfProductPricing extends DaoModel {
  constructor(guid, name, pointOfSaleGuid) {
    super(guid);
    this.name = name || '';
    this.pointOfSaleGuid = pointOfSaleGuid;
  }

  static toInstance(props = {}) {
    return new GroupOfProductPricing(props.guid, props.name, props.point_of_sale);
  }
}
